module.exports = __webpack_public_path__ + "static/media/desktop16.077315d3.png";